import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import IconExample from '../examples/Icon';
import IconSizeExample from '../examples/IconSize';
const IconExampleSource = require('!!raw-loader!../examples/Icon');
const IconSizeExampleSource = require('!!raw-loader!../examples/IconSize');
export default class IconsPage extends React.Component {
    render() {
        return (<div>
                <div>
                    <Helmet title="Icons"/>
                    <h3>Icons</h3>
                    <div className="docs-example">
                        <IconExample />
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{IconExampleSource}</PrismCode>
                    </pre>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
SvgIcon.propTypes = {
    className: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    kind: PropTypes.oneOf([...]).isRequired, // Kind of icon
    onClick: PropTypes.func,
    preview: PropTypes.bool,
    size: PropTypes.number,
    style: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    wrapperStyle: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ])
};

SvgIcon.defaultProps = {
    size: 32,
};
`}
                        </PrismCode>
                    </pre>
                </div>
                <div>
                    <h3>Icon Sizes</h3>
                    <p>If you do not want to use the optional icon sizes, we also have predefined sizes.</p>
                    <div className="docs-example">
                        <div className="flex">
                            <IconSizeExample />
                        </div>
                    </div>
                    <pre>
                        <PrismCode className="language-jsx">{IconSizeExampleSource}</PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
